<template>
    <div class="must-have-exactly-one-root-element">

        <!-- Menu -->
        <menu-obchod
            @hideSideMenu="hideSideMenu"
            :kravicka="kravicka"
            :sideMenu="sideMenu"
        />

        <!-- Shop phone -->
        <button @click="sideMenu = !sideMenu" id="openShopMenu" class="btn --primary d-xl-none" style="z-index:61"><span class="icon"></span></button>

        <main class="shopMain --lightBg">
            <div class="shopHeader --whiteBg d-flex">
                <h2 class="mb-0">Zmenáreň</h2>

                <!-- Header -->
                <header-obchod
                    @updateProfil="emitUpdateProfil"
                    :profil="profil"
                />
            </div>

            <!-- Alert box -->
            <div v-if="responseText != ''" :class="'alert alert-dismissible fade show --shopAlert alert-'+responseType" role="alert">
                <p class="mb-0">
                    <span :class="'icon --'+responseType"></span>{{ responseText }}
                </p>

                <button @click="responseText = ''" type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <!-- Zmenáreň -->
            <div class="o-zmenarenMain">
                <div class="row">
                    <div class="col-12 col-md-12 col-lg-12 col-xl-6 position-normal">
                        <h3>Zameniť EAN kódy za dukáty</h3>
                        <!--<p>Za každý správne pridaný EAN kód ti bude pripísaných 5 dukátov. Za <br>
                            dukáty môžeš nakupovať kravičke rôzne veci a robiť ju tak šťastnou.</p>-->
                        <!--<p>Za každý správne pridaný EAN kód ti bude pripísaných
                            <template v-if="!profil.pouzivatel_id.pouzivatel_group" >10 dukátov</template>
                            <template v-else>10 dukátov</template>. Za <br>
                            dukáty môžeš nakupovať kravičke rôzne veci a robiť ju tak šťastnou.</p>-->
                            <p>Za každý správne pridaný EAN kód ti bude pripísaných
                            <template v-if="!profil.pouzivatel_id.pouzivatel_group" >5 dukátov</template>
                            <template v-else>1 dukát</template>. Za <br>
                            dukáty môžeš nakupovať kravičke rôzne veci a robiť ju tak šťastnou.</p>

                        <!-- Form Box -->
                        <form @submit="formSubmit" class="zmenarenForm">
                            <div class="form-group">
                                <label for="ean_kod">EAN kód mliečneho výrobku 
                                    <a id="popoverEan" class="float-right mr-4">Kde nájdem EAN kód?</a>
                                    <b-popover target="popoverEan" triggers="click" placement="top">
                                        <template slot="title">Kde ho nájdem?</template>
                                        <div class='text-center'><p>Kódy EAN sa používajú na označovanie tovaru. Nájsť ich môžeš na obaloch produktov.</p><p><img src='https://www.adoptujkravicku.sk/hra/dist/images/content/ean-kod.jpg'></p></div>
                                    </b-popover>
                                </label>
                                <popover name="zmenaren"><div class='text-center'><p>Kódy EAN sa používajú na označovanie tovaru.<br> Nájsť ich môžeš na obaloch produktov.</p><p><img src='https://www.adoptujkravicku.sk/hra/dist/images/content/ean-kod.jpg'></p></div></popover>
                            </div>
                            <div class="form-group">
                                <input type="text" v-model="ean_code">
                            </div>
                            <button type="submit" class="btn --primary"><span class="icon"></span>Zameniť ean kód</button>
                        </form>
                        <!-- .Form Box -->                        
                    </div>

                    <!-- Banner -->
                    <div class="col-12 col-md-12 col-lg-12 col-xl-6">
                        <div class="o-applicationBanner">
                            <div class="m-applicationBanner__content">
                                <div class="a-applicationBanner__title">
                                    <h3>Skenujte EAN kódy pomocou novej mobilnej aplikácie pre <a href="https://apps.apple.com/cz/app/adoptuj-kravi%C4%8Dku-skener/id1432428434">iOS</a> a <a href="https://play.google.com/store/apps/details?id=sk.smr.adoptujkravicku">Android</a>.</h3>                        
                                </div>
                                <div class="a-applicationBanner__btns">
                                    <a href="https://apps.apple.com/cz/app/adoptuj-kravi%C4%8Dku-skener/id1432428434"><img class="img-fluid mr-md-2 mr-0 mb-1 mb-md-0" src="assets/img/applestore.png" alt=""></a>
                                    <a href="https://play.google.com/store/apps/details?id=sk.smr.adoptujkravicku"><img class="img-fluid" src="assets/img/gplay.png" alt=""></a>
                                </div>
                            </div>
                            <div class="m-applicationBanner__image">
                                <img class="img-fluid" src="assets/img/imgAppScreen.png" alt="Mockup aplikácie">
                            </div>
                        </div>    
                    </div>
                    <!-- .Banner -->

                </div>
            </div>
            <!-- .Zmenáreň -->

        </main>

    </div>
</template>



<script>
    import EventService from '@/services/EventService.js'
    import HeaderObchod from '../partials/HeaderObchod.vue'
    import MenuObchod   from '../partials/MenuObchod.vue'
    export default {
        components: {
            HeaderObchod,
            MenuObchod
        },
        props: [
            'profil',
            'kravicka'
        ],
        mounted() {
            this.getKravickaData()
        },
        data() {
            return {
                ean_code: '',
                sideMenu: false,

                responseType: '',
                responseText: ''
            }
        },
        methods: {
            // emit
            emitUpdateProfil() {
                this.$emit('updateProfil')
            },

            hideSideMenu() {
                this.sideMenu = false
            },


            // mounted
            getKravickaData() {
                if (typeof(this.kravicka.id) == 'undefined' || this.$route.params.kravicka_id != this.kravicka.id) {
                    this.$emit('update:kravicka', {})
                    EventService.getKravickaData(this.$route.params.kravicka_id)
                        .then(response => {
                            //console.log(response.data)
                            this.param_global = Number((response.data.data[0].kravicka_param_global).toFixed(0))
                            this.$emit('update:kravicka', response.data.data[0])
                        })
                        .catch(error => {
                            this.responseType = 'warning'
                            this.responseText = error
                        })

                } else {
                    //console.log(this.kravicka)
                    this.param_global = Number((this.kravicka.kravicka_param_global).toFixed(0))
                }
            },


            // submit
            formSubmit(e) {
                e.preventDefault()
                this.eanExchange()
            },

            eanExchange() {
                if (this.ean_code != '') {
                    EventService.eanExchange('exchange', this.profil.pouzivatel_id.pouzivatel_group, this.kravicka.dvor_id.id, this.ean_code, this.kravicka.id, this.profil.pouzivatel_id.id, this.profil.pouzivatel_id.pouzivatel_name, this.profil.pouzivatel_email)
                        .then(response => {
                            //console.log(response.data)
                            this.responseType = response.data.code
                            this.responseText = response.data.data

                            if (response.data.code == 'success') {
                                //this.profil.pouzivatel_id.pouzivatel_wallet += parseFloat(response.data.value)
                                var wallet = parseFloat(this.profil.pouzivatel_id.pouzivatel_wallet) + parseFloat(response.data.value)
                                this.profil.pouzivatel_id.pouzivatel_wallet = wallet
                                this.$emit('update:profil', this.profil)

                                // vyčisti ean input
                                this.ean_code = ''

                                // achievements ids (50, 500, 1000 eans)
                                this.achievements(20)
                                this.achievements(21)
                                this.achievements(27)
                            }
                            this.playSound('assets/audio/mince.wav')
                        })
                        .catch(error => {
                            this.responseType = 'warning'
                            this.responseText = error
                        })
                }
            },

            playSound: function(src) {
                var sound = new Audio(src)
                sound.play()
            },


            // achievements
            achievements(uid) {
                var key = EventService.checkAchievementProgress(this.profil, uid)
                if (key > -2) {
                    EventService.setAchievementProgress(this.profil, uid)
                        .then(response => {
                            //console.log(response.data)
                            //this.responseType = response.data.code
                            //this.responseText = response.data.data

                            sessionStorage.removeItem("login")
                            sessionStorage.setItem("album-uspechy", "refresh")

                            if (key == -1) {
                                this.$emit('updateProfil')
                            } else {
                                this.profil.pouzivatel_id.album_pouzivatela[key].repozitar_albumu_current += 1
                                this.$emit('update:profil', this.profil)
                            }

                            // achievements toast popup
                            this.$toast.success(' ', response.data.data)
                        })
                        .catch(error => {
                            this.responseType = 'warning'
                            this.responseText = error
                        })
                }
            },
        }
    }
</script>
